import request from 'api/request';

export default function acceptInvitationRoute(id) {
  return request({ url: `/invitations/${id}/accept`, method: 'PUT' });
}
